import { Box, Radio, VStack } from "@chakra-ui/react"
import { newReleasesOptions } from "@components/Search/Filters/NewReleasesFilter"
import { useNumericMenu } from "@hooks/search/useNumericMenu"
import { useSortBy } from "@hooks/search/useSortBy"

export const sortOptions = [
  {
    label: "Featured",
    value: "products",
  },

  {
    label: "Price: Low to High",
    value:
      "products/sort/offers.lowPrice:asc,offers.availability(missing_values: last):asc",
  },

  {
    label: "Price: High to Low",
    value:
      "products/sort/offers.lowPrice:desc,offers.availability(missing_values: last):asc",
  },

  {
    label: "Avg. Customer Review",
    value:
      "products/sort/aggregateRating.ratingCount:desc,aggregateRating.ratingValue:desc,offers.availability(missing_values: last):asc",
  },

  {
    label: "New Arrivals",
    value:
      "products/sort/datePublished:desc,offers.availability(missing_values: last):asc",
  },
]
const SortByFilter = ({ onClose }: { onClose?: () => void }) => {
  const { currentRefinement, options, refine } = useSortBy({
    items: sortOptions,
  })

  const { items, refine: refineDatePublished } = useNumericMenu({
    attribute: "datePublished",
    items: newReleasesOptions(),
  })

  return (
    <VStack alignItems={"start"}>
      {options.map((option, index) => (
        <Radio
          key={option.value}
          isChecked={option.value === currentRefinement}
          onChange={() => {
            if (index === 4) {
              refineDatePublished(items[1].value)
            }
            refine(option.value)
            onClose?.()
          }}
          colorScheme={"yellow"}
          value={option.value}
        >
          <Box
            as={"span"}
            fontSize={"sm"}
          >
            {option.label}
          </Box>
        </Radio>
      ))}
    </VStack>
  )
}

export default SortByFilter
